// extracted by mini-css-extract-plugin
export var messageSideLeft = "_ou-1";
export var messageSideRight = "_ou-2";
export var orderLookupBubbleContainer = "_ou-0";
export var submitButton = "_ou-3";